var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.submitted)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n    Deine Nachricht wurde gesendet.\n  ")]):_c('resource',{attrs:{"resource":"adminSupportMessage","notification":"Nachricht wurde gesendet","attributes":[
      {
        name: 'moderator_id',
        label: 'ID',
        type: 'StaticText',
        value: this.moderatorId
      },
      {
        name: 'copy_to_agency_leader',
        label: 'Kopie an Agenturleitung',
        type: 'CheckboxSelector',
        value: false
      },
      {
        name: 'message',
        label: 'Nachricht',
        type: 'TextareaSelector'
      }
    ]},on:{"resource-persisted":function($event){_vm.submitted = true}}},[(!_vm.noTitle)?_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Moderator kontaktieren")])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }